import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import RoomTheme from "%/dynamic-component-editor/options/room-theme";
import ShowEventTitle from "%/dynamic-component-editor/options/show-event-title";
import ShowElapsedTimer from "%/dynamic-component-editor/options/show-elapsed-timer";
import ShowLiveBadge from "%/dynamic-component-editor/options/show-live-badge";
import ShowViewerCount from "%/dynamic-component-editor/options/show-viewer-count";
import ShowStatusChip from "%/dynamic-component-editor/options/show-status-chip";
import IntermissionImage from "%/dynamic-component-editor/options/intermission-image";
import IntermissionText from "%/dynamic-component-editor/options/intermission-text";

export default class EventRoomOptions extends BaseOptionsBundle {

  optionTitle = "Room";
  static optionClassName = "i-dynamic-event-room-bundle";

  constructor(values = {}) {
    super(values, [
      RoomTheme,
      ShowEventTitle,
      ShowElapsedTimer,
      ShowLiveBadge,
      ShowViewerCount,
      ShowStatusChip,
      IntermissionImage,
      IntermissionText,
    ]);
  }
}
